<template>
  <div class="modal-card">
    <b-loading :isFullPage="false" :active="isLoading" />
    <header class="modal-card-head">
      <span class="modal-card-title is-size-5 has-text-centered">{{
        App.ModalNoEffect.TITLE
      }}</span>
      <div class="close-button cursor-pointer" @click.stop="$emit('close')">
        <b-icon icon="close" />
      </div>
    </header>

    <div class="modal-content-container">
      <section class="spacing-p-10">
        <b-field :label="General.REASON" class="column is-6">
          <b-dropdown v-model="reasonOption" aria-role="menu">
            <template slot="trigger">
              <b-button
                slot="trigger"
                class="input level"
                type="is-light"
                iconRight="chevron-down"
                outlined
              >
                <span>{{ reasonOption[1] || General.SELECT_AN_REASON }}</span>
              </b-button>
            </template>

            <b-dropdown-item
              v-for="option in optionsReason"
              :key="option[0]"
              aria-role="listitem"
              :value="option"
            >
              {{ option[1] }}
            </b-dropdown-item>
          </b-dropdown>
        </b-field>
        <b-field :label="General.DESCRIPTION" class="column is-12">
          <b-input
            v-model="message"
            maxlength="200"
            type="textarea"
            :placeholder="App.ModalNoEffect.TEXT_PLACEHOLDER"
          ></b-input>
        </b-field>
      </section>

      <footer class="modal-card-foot custom-align-left">
        <div class="buttons">
          <b-button type="is-primary" @click="confirmAction">
            {{ General.SAVE.toUpperCase() }}
          </b-button>
          <b-button
            type="is-primary"
            class="is-outlined"
            @click="$emit('close')"
          >
            {{ General.CANCEL.toUpperCase() }}
          </b-button>
        </div>
      </footer>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";

import { App, General } from "../../utils/constants";

export default {
  name: "ModalNoEffect",

  props: {
    processFileId: {
      type: String,
      default: null
    },
    clearSelection: {
      type: Function,
      default: () => null
    },
    onClose: {
      type: Function,
      default: null
    }
  },

  data() {
    return {
      App,
      General,
      isLoading: false,
      reasonOption: "",
      message: ""
    };
  },

  computed: {
    optionsReason() {
      return Object.entries(this.App.ModalNoEffect.REASONS);
    }
  },

  methods: {
    ...mapActions({ setProcessFileNoEffect: "setProcessFileNoEffect" }),

    async confirmAction() {
      if (this.message.length && this.reasonOption) {
        this.isLoading = true;

        const processFileNoEffect = {
          processFileId: this.processFileId,
          noEffectMotivation: this.reasonOption[0],
          noEffectJustification: this.message
        };
        await this.setProcessFileNoEffect(processFileNoEffect);
        this.isLoading = false;
        this.close();
        this.onClose ? this.onClose() : window.location.reload();
      } else {
        this.snackToast.open({
          message: this.General.TEXTS.AWAITING_CONTENT,
          type: "is-danger",
          duration: 8000
        });
      }
    },

    close() {
      this.clearSelection();
      this.$parent.close();
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variables";

.modal-card {
  display: flex;
  justify-content: space-between;
  min-height: 360px;
  width: 600px;
  background-color: #ffffff;

  @media only screen and (max-width: $tablet) {
    width: 100%;
  }
}

.modal-content-container {
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  justify-content: space-between;
}

.custom-align-left {
  justify-content: flex-end;
}
</style>
